module.exports = __webpack_public_path__ + "img/linkedIcon.bc64a0ad.png";